import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LiveTextServerTime from './live-text-server-time';

const LiveTextFilter = ({ isFiltered, filterByVideo }) => {
    const buttonCss = classNames({
        'is-active': isFiltered
    });

    return (
        <div className="live-text-filter">
            <div className="live-text-filter__date">
                <LiveTextServerTime />
            </div>
            <button
                className={`live-text-filter__video-btn ${buttonCss}`}
                type="button"
                onClick={filterByVideo}
            >
                <span>Filter</span>
                <svg
                    className="live-text-filter__video-btn-icon icon"
                    width="15"
                    height="11"
                    focusable="false"
                >
                    <use xlinkHref="#icon-watch"></use>
                </svg>
            </button>

        </div>
    );
};

LiveTextFilter.defaultProps = {
    filterByVideo: () => {}
};


LiveTextFilter.propTypes = {
    isFiltered: PropTypes.bool,
    filterByVideo: PropTypes.func
};

export default LiveTextFilter;
